var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Col } from "react-bootstrap";
import { get } from "lodash";
import { connect } from "react-redux";
import id from "@irati/utils/id";
import Form, { FormGroup } from "@irati/ui/src/Form";
import Button from "@irati/ui/src/Button";
import { Input } from "@irati/ui/src/FormItem";
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton";
import { Password } from "@irati-web/fields/user";
import HR from "@irati/ui/src/Layout/Hr";
import Validation from "@irati/utils/validation";
import authentication from "@irati/auth";
import Loading from "@irati/ui/src/Loading";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { initiateSamlLogin } from "@irati/sso/helpers/webSSOPopup";
import loginService from "@irati/auth/services/login";
import LoginBlock from "../../../components/LoginBlock";
import LoginPicAndHeader from "../../../components/LoginPicAndHeader/LoginPicAndHeader";
import ForgotButton from "../styled/ForgotButton";
import SingleSignOn from "../styled/SingleSignOn";
import LoginFormWrapper from "../styled/LoginFormWrapper";
import StyledCheckbox from "../styled/StyledCheckbox";
import StyledLoginCard from "../styled/LoginCard";
var FullLogin = /** @class */ (function (_super) {
    __extends(FullLogin, _super);
    function FullLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            email: "",
            password: "",
            rememberMe: true,
            load: null,
            submit: null
        };
        _this.handleSubmit = function () {
            var onContinue = _this.props.onContinue;
            var _a = _this.state, email = _a.email, password = _a.password;
            var submit = loginService.login(authentication.unAuthedBusiness(), email, password).then(onContinue);
            _this.setState({ submit: submit });
        };
        _this.handleChangeEmail = function (email) { return _this.setState({ email: email, load: null }); };
        _this.handleChangePassword = function (password) { return _this.setState({ password: password, load: null }); };
        _this.updateRememberMe = function () { return _this.setState({ rememberMe: !_this.state.rememberMe }); };
        _this.handleEnter = function () {
            return Validation.validate()
                .then(_this.handleSubmit)
                .catch(function () { });
        };
        _this.emailValidation = function () {
            var schema = Validation.string("platform.defaultLogin.fields.emailValidation.enterEmail");
            return schema.email("platform.defaultLogin.fields.emailValidation.notValid");
        };
        _this.singleSignOnRedirect = function () {
            var onContinue = _this.props.onContinue;
            return initiateSamlLogin(authentication.unAuthedBusiness()).then(function (response) {
                var access_token = response.access_token, user = response.user, tenant = response.tenant;
                var submit = loginService.ssoLogin(tenant, user, access_token).then(onContinue);
                _this.setState({ submit: submit });
                return submit;
            });
        };
        return _this;
    }
    FullLogin.prototype.componentDidMount = function () {
        var postedEmail = this.props.postedEmail;
        if (postedEmail) {
            this.setState({ email: postedEmail });
        }
    };
    FullLogin.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, idNamespace = _a.id, headerOne = _a.headerOne, headerTwo = _a.headerTwo, ssoButtonText = _a.ssoButtonText;
        var _b = this.state, email = _b.email, password = _b.password, rememberMe = _b.rememberMe, submit = _b.submit;
        var business = authentication.unAuthedBusiness();
        var isSSO = business.showSsoLogin;
        var isWindowSizeGreaterThanSmall = get(this.props.mq, "greaterThan.small", false);
        return (React.createElement("div", { id: idNamespace, className: "default_login-container" },
            React.createElement(LoginBlock, { id: idNamespace, size: isSSO && isWindowSizeGreaterThanSmall ? "large" : "small" },
                React.createElement(StyledLoginCard, { id: id("card", idNamespace), large: true },
                    React.createElement(LoginFormWrapper, { id: id("form-wrapper", idNamespace), isSSO: isSSO && isWindowSizeGreaterThanSmall },
                        React.createElement(LoginPicAndHeader, { name: idNamespace },
                            headerOne,
                            React.createElement("br", null),
                            headerTwo),
                        React.createElement(Form, null,
                            React.createElement(Input, { id: id("field-email", idNamespace), label: formatMessage({ id: "platform.defaultLogin.fields.email.label" }), name: "email", type: "email", value: email, placeholder: formatMessage({ id: "platform.defaultLogin.fields.email.placeholder" }), onChange: this.handleChangeEmail, onEnter: this.handleEnter, validation: this.emailValidation() }),
                            React.createElement(Password, { id: id("field-password", idNamespace), label: formatMessage({ id: "platform.defaultLogin.fields.password.label" }), value: password, noValidation: true, isRequired: true, placeholder: formatMessage({ id: "platform.defaultLogin.fields.password.placeholder" }), onChange: this.handleChangePassword, onEnter: this.handleEnter }),
                            React.createElement(FormGroup, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(ForgotButton, { id: id("btn-forgot", idNamespace), cta: true, to: "/welcome/login/forgotten-password" },
                                        React.createElement(FormattedMessage, { id: "platform.defaultLogin.fields.button.forgotPassword" }),
                                        "?"))),
                            React.createElement(StyledCheckbox, { id: id("field-remember-me", idNamespace), name: "rememberMe", checked: rememberMe, onChange: this.updateRememberMe },
                                React.createElement(FormattedMessage, { id: "platform.defaultLogin.fields.rememberMe.label" })),
                            React.createElement(Loading, { id: id("submit-response", idNamespace), load: submit, useLoader: false }),
                            React.createElement(ValidationButton, { primary: true, large: true, full: true, id: id("btn-submit", idNamespace), load: submit, onClick: this.handleSubmit },
                                React.createElement(FormattedMessage, { id: "platform.defaultLogin.fields.button.login" }))),
                        isSSO && !isWindowSizeGreaterThanSmall && (React.createElement("div", null,
                            React.createElement(HR, null),
                            React.createElement(Button, { primary: true, full: true, large: true, id: id("btn-sso-mobile", idNamespace), onClick: this.singleSignOnRedirect }, ssoButtonText)))),
                    isSSO && isWindowSizeGreaterThanSmall && (React.createElement(SingleSignOn, null,
                        React.createElement(Button, { primary: true, id: id("btn-sso-desktop", idNamespace), load: submit, onClick: this.singleSignOnRedirect }, ssoButtonText)))))));
    };
    FullLogin.defaultProps = {
        postedEmail: null
    };
    return FullLogin;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({ mq: mq });
};
export default injectIntl(connect(mapStateToProps)(FullLogin));
